import styles from "./RecommendationListItem.module.css";
import badge from "../../img/badge.png";
import time from "../../img/time.png";
import fire from "../../img/fire.png";
import MapKeywordItem from "./MapKeywordItem";
import { useNavigate } from "react-router";
import { path } from "../common/Common";
import { HOME_URL } from "../../data_provider/Config";

export interface RecommendationListItemProps {
    mapId: string;
    title: string;
    keyword: string;
    mainImage: string;
    recommendType: string;
}
/**
 * @author cjs
 * @date 2024-08-20 17:26:34
 * @remark 공개 지도 추천 목록 아이템
 * @param props ItemProps
 * @props item (required) : 추천 지도 아이템
 * @returns <div>
 */
function RecommendationListItem(props: RecommendationListItemProps) {
    const navigate = useNavigate();
    const RecommendIcon: { [key: string]: any } = {
        recommend: {
            icon: time,
            title: "관리자 추천",
        },
        fire: {
            icon: fire,
            title: "인기급상승",
        },
        userPick: {
            icon: badge,
            title: "이용자의 선택",
        },
    };

    const onClickItem = () => {
        const url = path.MAP;
        const params = `id=${props.mapId}`;
        const request = `${url}?${params}`;

        // navigate(request);
        window.open(request, "_blank"); // 새창(또는 새탭)으로 열기
    };

    return (
        <div className={styles.wrap} onClick={onClickItem}>
            <div className={styles.wrapThumbnail}>
                <img
                    className={styles.thumbnail}
                    src={props.mainImage ?? `${HOME_URL}/modoomap_image/thumbnail/${props.mapId}.png`}
                    alt="메인 이미지"
                ></img>
            </div>
            <div className={styles.header}>
                <img className={styles.icon} src={RecommendIcon[props.recommendType].icon} alt="아이콘"></img>
                <div className={styles.recommendationCategory}>{RecommendIcon[props.recommendType].title}</div>
            </div>
            <div className={styles.footer}>
                <div className={styles.wrapFooter}>
                    <div className={styles.title}>{props.title}</div>

                    <div className={styles.keywords}>
                        {props.keyword &&
                            JSON.parse(props.keyword).map((item: string, idx: number) => {
                                return <MapKeywordItem title={item} key={`recomment_${idx}`} />;
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecommendationListItem;
